import { FilledNewIconProps } from '@diritto/common/style/icon';
import { twMerge } from 'tailwind-merge';

export const MyIcon = ({ fill, color, className }: FilledNewIconProps) =>
  fill ? (
    <svg
      className={twMerge('size-[26px]', className)}
      width="100%"
      height="100%"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25 4H1V9H25V4ZM3 11H23V22H3V11ZM10 13H16V15H10V13Z"
        fill={color}
      />
    </svg>
  ) : (
    <svg
      className={twMerge('size-[26px]', className)}
      width="100%"
      height="100%"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 6H3V9H23V6ZM1 11H3V22H23V11H25V4H1V11ZM5 20V11H21V20H5ZM16 13H10V15H16V13Z"
        fill={color}
      />
    </svg>
  );
